export default __webpack_public_path__ + "static/media/right-expand.b570f486.svg";